import {ModalService} from '../../services/modal.service';
import {Component, Inject} from '@angular/core';
import {ModalComponent} from './modal.interface';
import {DialogButtonComponent} from '../buttons/dialog-button.component';
import { CommonModule } from '@angular/common';
import { WebCodeModalComponent } from './web-code-dialog.component';
import { OrderService } from '../../services/order.service';
import {TranslateService} from '../../services/translate.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    DialogButtonComponent
  ],
  template: `
    <div class="bg-theme-surface2 rounded-2xl shadow-xl w-64">
      <div class="p-6 w-full">
        <h2 class="text-xl font-bold mb-4">{{ data.title }}</h2>
        <p>{{ data.message }}</p>
        <div class="mt-4 flex flex-col gap-2 items-center">
          <div *ngFor="let button of data.buttons">
            <app-dialog-button customClass="w-52" [text]="button.text" (onClick)="dialogButtonAction(button.action)" variant="primary"></app-dialog-button>
          </div>
          <app-dialog-button customClass="w-52" [text]="translate.getString('Avbryt')" (onClick)="close(false)"></app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class RescanDialogComponent implements ModalComponent {
  modalData?: any;
  buttons: { action: string, text: string }[] = [];

  constructor(
    protected translate: TranslateService,
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: {
      title: string;
      message: string;
      buttons: { action: string, text: string }[];
    },
    private order: OrderService
  ) {
    this.modalData = data;
  }

  close(value: any = false) {
    this.modalService.close(value);
  }

  confirm() {
    this.order.confirmTable().subscribe(result => {
      this.close(true);
    });
  }

  changeTable() {
    this.modalService.close(false);
    const dialogRef = this.modalService.show(WebCodeModalComponent, {
      closeOnBackdrop: false,
      data: {}
    });

  }

  dialogButtonAction(action: string) {
    switch(action) {
      case 'confirm':
        this.confirm();
        break;
      case 'changeTable':
        this.changeTable();
        break;
      default :
        this.close(false);
    }
  }
}
